<template>
    <div>
        <!-- Heading and Filter -->
        <div class="d-flex flex-column flex-lg-row align-items-lg-center justify-content-lg-between mb-5">
            <!-- Heading -->
            <div class="d-flex flex-column flex-md-row align-items-md-center">
                <h1 class="mb-4 mb-md-0 mr-5">
                    My Properties
                </h1>
                <router-link
                    :to="{ name: 'checkout' }"
                    class="btn btn--primary"
                >
                    Add new Property
                </router-link>
            </div>
            <!-- END Heading -->

            <!-- Filters -->
            <ul class="list-unstyled mb-0 mt-4 mt-lg-0 filter-menu">
                <li><span>Filter</span></li>
                <li>
                    <a
                        :class="{ active : activeFilter === '' }"
                        href="#"
                        @click.prevent="switchFilter('')"
                    >
                        All
                    </a>
                </li>
                <li>
                    <a
                        :class="{ active : activeFilter === 'sale' }"
                        href="#"
                        @click.prevent="switchFilter('sale')"
                    >
                        For Sale
                    </a>
                </li>
                <li>
                    <a
                        :class="{ active : activeFilter === 'let' }"
                        href="#"
                        @click.prevent="switchFilter('let')"
                    >
                        To Let
                    </a>
                </li>
            </ul>
            <!-- END Filters -->
        </div>
        <!-- END Heading and Filter -->

        <b-row class="mb-5">
            <b-col
                cols="12"
            >
                <p class="text-demibold">
                    This is where you view and manage all of your properties
                </p>
            </b-col>
        </b-row>

        <!-- Properties -->
        <b-row v-if="activeProperties.length">
            <!-- All properties -->
            <div
                v-for="property in activeProperties"
                :key="property.id"
                class="col-12 col-lg-6 mb-5"
            >
                <PropertyCard
                    :property="property"
                    :owned="true"
                    :icons="{
                        notifications: user.id === property.user_id,
                        messages: user.id === property.user_id,
                        edit: user.id === property.user_id,
                        save: user.id !== property.user_id,
                        view: true
                    }"
                />
            </div>
            <!-- END All properties -->
        </b-row>

        <b-row v-else>
            <b-col
                cols="12"
            >
                <p v-if="activeFilter === 'sale'">
                    You have no properties listed for sale
                </p>
                <p v-else-if="activeFilter === 'let'">
                    You have no properties listed for let
                </p>
                <p v-else>
                    You have no properties listed
                </p>
            </b-col>
        </b-row>
        <!-- END Properties -->
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import PropertyCard from '../components/PropertyCard';

export default {
    name: 'MyProperties',
    components: {
        PropertyCard
    },
    data() {
        return {
            activeFilter: ''
        };
    },
    computed: {
        ...mapState('user', ['user']),
        activeProperties() {
            if (this.activeFilter === 'sale') {
                return this.user.properties
                    && this.user.properties.filter(property => property.transaction_type === 'sale');
            }
            if (this.activeFilter === 'let') {
                return this.user.properties
                    && this.user.properties.filter(property => property.transaction_type === 'let');
            }
            return this.user.properties && this.user.properties.length ? this.user.properties : [];
        }
    },
    mounted() {
        this.refreshUser();
    },
    methods: {
        ...mapActions('user', ['refreshUser']),
        switchFilter(item) {
            this.activeFilter = item;
        }
    }
};
</script>

<style lang="scss">

</style>
